<template>
  <div class="page-container">
    <h2 class="title">Sejarah Permohonan / Escalate</h2>
    <p class="subtitle">Rekod perjalanan permohonan mengikut tarikh & pegawai</p>

    <div class="sejarah-list">
      <el-card
        v-for="(item, idx) in sejarahSorted"
        :key="idx"
        class="mb-3 sejarah-card"
        :class="statusClass(item.status)"
      >
        <div class="card-header">
          <strong>{{ formatDate(item.tarikh) }}</strong> 
          <span class="pegawai"> - {{ item.pegawai }}</span>
        </div>
        <div class="card-body">
          <p><strong>Status:</strong> {{ item.status }}</p>
          <p><strong>Catatan:</strong> {{ item.catatan }}</p>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { Card } from "element-ui";
import moment from "moment";

export default {
  name: "MDSejarah",
  components: {
    [Card.name]: Card
  },
  data() {
    return {
      sejarahPermohonan: [
        { tarikh: "2025-09-01", pegawai: "Pegawai A (Penyemak)", status: "Terima Permohonan", catatan: "Permohonan diterima untuk semakan awal." },
        { tarikh: "2025-09-05", pegawai: "Pegawai B (Pengurus)", status: "Escalate", catatan: "Hantar untuk kelulusan." },
        { tarikh: "2025-09-10", pegawai: "Pegawai C (Bahagian Kewangan)", status: "Escalate", catatan: "Semakan bahagian kewangan." },
        { tarikh: "2025-09-15", pegawai: "Pengarah", status: "Selesai", catatan: "Permohonan diluluskan." }
      ]
    };
  },
  computed: {
    sejarahSorted() {
      return [...this.sejarahPermohonan].sort((a, b) => new Date(a.tarikh) - new Date(b.tarikh));
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    statusClass(status) {
      if (status === "Selesai") return "status-selesai";
      if (status === "Escalate") return "status-escalate";
      if (status === "Terima Permohonan") return "status-terima";
      return "";
    }
  }
};
</script>

<style scoped>
.page-container {
  padding: 20px;
}
.title {
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 5px;
}
.subtitle {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 15px;
}
.sejarah-card {
  border-left: 5px solid #409EFF;
  transition: 0.3s;
}
.card-header {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 8px;
}
.card-header .pegawai {
  color: #666;
  font-weight: normal;
}
.card-body p {
  margin: 3px 0;
  font-size: 0.95rem;
}
.mb-3 {
  margin-bottom: 15px;
}

/* Warna ikut status */
.status-selesai {
  border-left: 5px solid #28a745 !important; /* hijau */
  background: #e8f8ee;
}
.status-escalate {
  border-left: 5px solid #ff9800 !important; /* oren */
  background: #fff4e5;
}
.status-terima {
  border-left: 5px solid #409EFF !important; /* biru */
  background: #e9f3ff;
}
</style>
